import Jsonp from "@/libs/jsonp";
import {
  Toast,
  Dialog,
} from "vant";
export const getShareInfo = (options, marketerId) => {//如果分享的内容会根据情况变化，那么这里可以传入分享标题及url
  var data = {
    saleManId: marketerId,
    currentUrl: encodeURIComponent(location.href),
  }
  Jsonp('//api.' + process.env.VUE_APP_HOST + '/ylxduser/bsc/getSdkInfo', data, 'jsoncallback')
    .then(res => {
      if (res && res.returnCode == '0000' && res.data) {
        let share = res.data
        options = options || {};
        options.shareTitle = options.shareTitle || document.title;
        options.shareContent = options.shareContent || document.title;
        options.url = options.url || location.href;
        options.listImage = options.listImage && options.listImage[0] || 'https://i0.ulecdn.com/i/global/ule.png';
        wx.config({
          beta: true,// 必须这么写，否则wx.invoke调用形式的jsapi会有问题
          debug: false,
          appId: share.appId,
          timestamp: share.timestamp,
          nonceStr: share.nonceStr,
          signature: share.signature,
          jsApiList: [
            'onMenuShareWechat',
            "onMenuShareTimeline",
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            "error"
          ]
        });
        wx.agentConfig({
          corpid: share.appId, // 必填，企业微信的corpid，必须与当前登录的企业一致
          agentid: share.agentid, // 必填，企业微信的应用id （e.g. 1000247）
          timestamp: share.timestamp, // 必填，生成签名的时间戳
          nonceStr: share.nonceStr, // 必填，生成签名的随机串
          signature: share.signature,// 必填，签名，见附录-JS-SDK使用权限签名算法
          jsApiList: [
            'onMenuShareWechat',
            "onMenuShareTimeline",
            'onMenuShareAppMessage',
            "error"
          ],
          success: function (res) {
            // 回调
            // alert('成功')
          },
          fail: function (res) {
            if (res.errMsg.indexOf('function not exist') > -1) {
              alert('版本过低请升级')
            }
          }
        });
        wx.ready(function () {
          var shareObj = {
            title: options.shareTitle,
            desc: options.shareContent,
            link: options.url,
            imgUrl: options.listImage,
            // 用户点击分享后执行的回调函数
            trigger: function (res) {
              // alert('分享')
            },
            // 用户确认分享后执行的回调函数
            success: function (res) {
              // alert('确认分享')
            },
            // 用户取消分享后执行的回调函数
            cancel: function (res) {
              // alert('取消分享')
            },
            fail: function (res) { }
          };
          // alert('share.appId')
          // alert(share.appId)
          //获取“微信”按钮点击状态及自定义分享内容接口
          wx.onMenuShareWechat(shareObj);
          // 分享到朋友圈
          wx.onMenuShareTimeline(shareObj);
          // 分享到朋友
          wx.onMenuShareAppMessage(shareObj);
          // 分享到QQ
          wx.onMenuShareQQ(shareObj);
          // 分享到腾讯微博
          wx.onMenuShareWeibo(shareObj);
          wx.error(function (res) {
            // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
            // alert("errorMSG:" + res);
          });
        });
      } else {
        Dialog
        .confirm({
          title: "提示",
          message: "您的分享信息丢失，请点击确认重新获取",
        }).then(()=>{
          getShareInfo(options, marketerId)    
        }).catch(()=>{

        })   
      };
    }).catch(err=>{
      Dialog
      .confirm({
        title: "提示",
        message: "您的分享信息丢失，请点击确认重新获取",
      }).then(()=>{
        getShareInfo(options, marketerId)    
      }).catch(()=>{

      })       
      console.log('getSdkInfo接口调用失败',err);
    })
}